/**
 * Get the number of days from today.
 * @param date The date to compare against today
 * @returns The number of days (positive = future; negative = past)
 */
export function getDaysFromToday(date: Date): number {
    const now = new Date();

    const timeDiff = date.getTime() - now.getTime();
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    return daysDiff;
}
